// UI
export const getPersonalSettingsUi = state => state.personalSettings.get('ui')
export const getPreviewUrl = state => getPersonalSettingsUi(state).get('previewUrl')
export const getUserImage = state => getPersonalSettingsUi(state).get('uploadedPhoto')
